// extracted by mini-css-extract-plugin
export default {"button":"styles_button__cXPek","exit-icon":"styles_exit-icon__-wt9J"};